import { Action } from '@ngrx/store';
import { AdditionalService } from '@cemex-core/cmx-api';

export enum AdditionalServicesActionTypes {
  LOAD = '[Additional Services] Load',
  LOAD_COMPLETE = '[Additional Services] Load complete',
  RESET = '[Additional Services] Reset',
}

export class AdditionalServicesLoadAction implements Action {
  readonly type = AdditionalServicesActionTypes.LOAD;

  constructor() {}
}

export class AdditionalServicesLoadCompleteAction implements Action {
  readonly type = AdditionalServicesActionTypes.LOAD_COMPLETE;

  constructor(public payload: AdditionalService[]) {}
}

export class AdditionalServicesResetAction implements Action {
  readonly type = AdditionalServicesActionTypes.RESET;

  constructor() {}
}

export type AdditionalServicesActions =
  | AdditionalServicesLoadAction
  | AdditionalServicesLoadCompleteAction
  | AdditionalServicesResetAction;
